// Per-column cache — see docs/skeleton_count_caching.md. Flat (not scoped to
// an org/parent id) since there's exactly one board per user; scoped by
// column status instead, since "Pending" and "Completed" typically hold very
// different counts and a single shared number would misrepresent one column
// or the other.
import { getCachedSkeletonCount, setCachedSkeletonCount } from './useSkeletonCountCache'

const DEFAULT_COUNTS = { pending: 3, started: 2, paused: 1, completed: 2 }

export function getCachedBoardColumnCount(status) {
  return getCachedSkeletonCount(`tasks_board:${status}`, DEFAULT_COUNTS[status] ?? 3)
}

export function setCachedBoardColumnCount(status, count) {
  setCachedSkeletonCount(`tasks_board:${status}`, count)
}
